import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import Dropzone from 'react-dropzone-component';
import classnames from 'classnames';
import DropzoneComponentMixin from '../mixins/DropzoneComponentMixin';

export const PASTE = 'PASTE';
export const DROPZONE = 'DROPZONE';
export const SVG = 'SVG';
export const TYPEFACE = 'TYPEFACE';

const messages = {
  SVG: {
    uploadLabel: 'SVG Upload',
    helpMessage: 'Uploaded SVG file should be a single color vector with non-overlapping paths.',
  },
  TYPEFACE: {
    uploadLabel: 'File',
    helpMessage: 'Select on OTF or TTF font file.',
  },
};

export default createReactClass({
  propTypes: {
    options: PropTypes.array,
    which: PropTypes.oneOf([PASTE, DROPZONE]),
    type: PropTypes.oneOf([SVG, TYPEFACE]),
    error: PropTypes.string,
    source: PropTypes.string,
    wrapperClassName: PropTypes.string,
    uploadLabel: PropTypes.string,
    helpMessage: PropTypes.string,
  },

  mixins: [ImmutableRenderMixin, DropzoneComponentMixin],

  getDefaultProps() {
    return {
      options: [PASTE, DROPZONE],
      which: PASTE,
      error: null,
      wrapperClassName: 'col-xs-9',
    };
  },

  getInitialState() {
    return {
      source: this.props.source,
    };
  },

  handleSvgChanged() {
    this.setState({
      source: this.refs.source.value,
    }, () => {
      this.props.onSourceChanged(this.refs.source.value);
    });
  },

  renderPaste() {
    const {error} = this.props;
    const svgFormGroupClassName = classnames(
      'form-group',
      'row',
      'text',
      'required',
      {'has-danger': !!error}
    );
    return (
      <div className={svgFormGroupClassName}>
        <label className="text required col-xs-3 form-control-label p-xs-r-sm">Paste from Illustrator CC <span title="Required">*</span></label>
        <div className="col-xs-9">
          <textarea onChange={this.handleSvgChanged} ref="source" value={this.state.source} className="text required form-control input-svg-source"></textarea>
          {(error) ? <span className="text-help text-muted p-xs-t-xs">{error}</span> : null}
          <p className="text-muted p-xs-t-xs">Copy your icon directly from Illustrator CC and paste in the above field. Icon should be a single color vector with non-overlapping paths.</p>
        </div>
      </div>
    );
  },

  renderDropzone() {
    const {error, type, wrapperClassName} = this.props;
    const svgFormGroupClassName = classnames(
      'form-group',
      'row',
      'text',
      'required',
      {'has-danger': !!error}
    );
    const {eventHandlers, djsConfig} = this.dropzoneProps();
    const config = {
      iconFiletypes: ['.svg'],
      showFiletypeIcon: true,
    };
    return (
      <div className={svgFormGroupClassName}>
        <label className="text required col-xs-3 form-control-label p-xs-r-sm">{this.props.uploadLabel || messages[type].uploadLabel} <span title="Required">*</span></label>
        <div className={wrapperClassName}>
          <Dropzone config={config} eventHandlers={eventHandlers} djsConfig={djsConfig}>
            <div className="dz-message"><i className="ficon ficon-plus-circle"></i>Drop files here or click to upload.</div>
          </Dropzone>
          {(error) ? <span className="text-help text-muted p-xs-t-xs">{error}</span> : null}
          <p className="text-muted p-xs-t-xs">{this.props.helpMessage || messages[type].helpMessage}</p>
        </div>
      </div>
    );
  },

  render() {
    return (this.props.which === PASTE) ? this.renderPaste() : this.renderDropzone();
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/PasteOrDropzone.js